import { render, staticRenderFns } from "./profitStatement.vue?vue&type=template&id=14f6cfda&scoped=true"
import script from "./profitStatement.vue?vue&type=script&lang=js"
export * from "./profitStatement.vue?vue&type=script&lang=js"
import style0 from "./profitStatement.vue?vue&type=style&index=0&id=14f6cfda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f6cfda",
  null
  
)

export default component.exports